import { useRMSelector } from 'redux/hooks';

export const useSelectedImagingScheduleID = () => {
  return useRMSelector((state) => state?.imagingSchedules?.selectedImagingScheduleID);
};

export const useImagingSchedulesIsDirty = () => {
  return useRMSelector((state) => state?.imagingSchedules?.isDirty);
};

export const useImagingSettingsID = () => {
  return useRMSelector((state) => state?.imagingSettings?.selectedImagingSettingsID);
};
export const useImagingSettingsRowNum = () => {
  return useRMSelector((state) => state?.imagingSettings?.selectedImagingSettingsRowNum);
};

export const useSelectedRobotId = () => {
  return useRMSelector((state) => state?.imagingSettings?.selectedRobotId);
};

export const useImagingSettingsDTO = () => {
  return useRMSelector((state) => state?.imagingSettings?.imagingSettingsDTO);
};

export const useScoreDefinitionDTO = () => {
  return useRMSelector((state) => state?.common?.scoreDefinition);
};

export const useScoreGroupsDTO = () => {
  return useRMSelector((state) => state?.common?.scoreGroups);
};
